var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vd__body"},[_c('div',{staticClass:"vd__header"},[_c('main-menu')],1),_c('div',{staticClass:"vd__page_body"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }